import type { AdditionalDataInputs } from '../providers/MessageFormContext.types';

const trimmed = (value?: string) => value?.trim() ?? '';

export const hasAdditionalDataValues = (data?: AdditionalDataInputs) =>
	Boolean(
		data?.intoTheirOwnHands ||
		data?.senderIdentification ||
		trimmed(data?.toTheHandsOf) ||
		trimmed(data?.naseSpisovaZnacka) ||
		trimmed(data?.naseCisloJednaci) ||
		trimmed(data?.vaseSpisovaZnacka) ||
		trimmed(data?.vaseCisloJednaci)
	);

export const additionalDataChanged = (
	edited: AdditionalDataInputs | undefined,
	applied: AdditionalDataInputs
) =>
	Boolean(
		edited?.intoTheirOwnHands !== applied.intoTheirOwnHands ||
		edited?.senderIdentification !== applied.senderIdentification ||
		trimmed(edited?.toTheHandsOf) !== trimmed(applied.toTheHandsOf) ||
		trimmed(edited?.naseSpisovaZnacka) !== trimmed(applied.naseSpisovaZnacka) ||
		trimmed(edited?.naseCisloJednaci) !== trimmed(applied.naseCisloJednaci) ||
		trimmed(edited?.vaseSpisovaZnacka) !== trimmed(applied.vaseSpisovaZnacka) ||
		trimmed(edited?.vaseCisloJednaci) !== trimmed(applied.vaseCisloJednaci)
	);
